import { render } from "./HistoricalInformation.vue?vue&type=template&id=4937525a&ts=true"
import script from "./HistoricalInformation.vue?vue&type=script&lang=ts"
export * from "./HistoricalInformation.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__